<div class="theme-switcher">
  <!-- Simple toggle button -->
  <button 
    class="theme-toggle-btn" 
    (click)="toggleTheme()"
    [title]="'Current theme: ' + currentTheme + '. Click to change.'"
  >
    <i class="fas fa-palette"></i>
    <span class="theme-indicator" [style.background-color]="getThemeColor(currentTheme)"></span>
  </button>

  <!-- Dropdown for theme selection -->
  <div class="theme-dropdown" *ngIf="false">
    <div class="theme-option" 
         *ngFor="let theme of availableThemes" 
         (click)="changeTheme(theme.value)"
         [class.active]="currentTheme === theme.value">
      <span class="theme-color" [style.background-color]="theme.color"></span>
      <span class="theme-label">{{ theme.label }}</span>
    </div>
  </div>
</div> 